import React from 'react';
import { PricingPollDone } from '../../../components/PricingPollDone/PricingPollDone';

export const getPricingPollDone = () => {
    return <PricingPollDone />;
}
